import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Auto-reload seguro quando um chunk antigo do Vite não for encontrado após novo deploy
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  const retryKey = 'vite_preload_retry_count';
  const retries = parseInt(sessionStorage.getItem(retryKey) || '0', 10);

  if (retries < 1) {
    sessionStorage.setItem(retryKey, String(retries + 1));
    window.location.reload();
  } else {
    console.error('⚠️ [Vite] Falha contínua ao carregar módulo após recarregar. Recarregamento cancelado para evitar loop infinito.');
    setTimeout(() => sessionStorage.removeItem(retryKey), 60000);
  }
});

// Reseta o contador se a aplicação rodar estável por mais de 10 segundos
setTimeout(() => {
  sessionStorage.removeItem('vite_preload_retry_count');
}, 10000);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

